import { combineReducers } from 'redux';
import { SET, SET_CARD, RESET } from './constants';
import valueReducer from '../../common/reducers/valueReducer';

const id = (state = '', { type, payload = {} }) => {
  switch (type) {
    case RESET:
      return '';
    case SET:
      return payload.id || payload.objectID || '';
    default:
      return state;
  }
};

const email = (state = '', { type, payload = {} }) => {
  switch (type) {
    case RESET:
      return '';
    case SET:
      return payload.email || '';
    default:
      return state;
  }
};

const phone = (state = '', { type, payload = {} }) => {
  switch (type) {
    case RESET:
      return '';
    case SET:
      return payload.phone || '';
    default:
      return state;
  }
};

const name = (state = '', { type, payload = {} }) => {
  switch (type) {
    case RESET:
      return '';
    case SET:
      return payload.name || '';
    default:
      return state;
  }
};

const paymentCard = valueReducer(null, SET_CARD);

const customer = combineReducers({
  id,
  email,
  phone,
  name,
  paymentCard,
});

export default customer;
